/**
 * -----------------------------------------------------------------------------------------------------------
 * Loading components
 * -----------------------------------------------------------------------------------------------------------
 */
import auth from 'src/router/auth'
import Blog from '../Blog'
import NewBlog from '../NewBlog'
import EditBlog from '../EditBlog'

/**
 * -----------------------------------------------------------------------------------------------------------
 * Define component
 * -----------------------------------------------------------------------------------------------------------
 */
export default [
  {
    path: '/blogs',
    name: 'blog',
    component: Blog,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/blogs/create',
    name: 'create-blog',
    component: NewBlog,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/blogs/edit/:id',
    name: 'edit-blog',
    component: EditBlog,
    beforeEnter: auth.requireAuth
  }
]



// WEBPACK FOOTER //
// ./src/components/blog/routes/index.js